import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/Footer.module.css'; // Ensure you have a CSS file for styling

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.footerSection}>
          <h3>Bakso the Tiger</h3>
          <p>A beacon of hope for Sumatran tiger conservation</p>
          <p>Born at Disney's Animal Kingdom, 2024</p>
        </div>
        
        <div className={styles.footerSection}>
          <h3>Visit Information</h3>
          <p>Maharaja Jungle Trek</p>
          <p>Disney's Animal Kingdom (DAK)</p>
          <p>2901 Osceola Parkway, Lake Buena Vista, FL 32830.</p>
          <p><Link to="https://disneyworld.disney.go.com/destinations/animal-kingdom/" style={{ color: '#ccc', textDecoration: 'none' }}>(DAK Website)</Link></p>
        </div>
        
        <div className={styles.footerSection}>
          <h3>Socials</h3>
          <p><Link to="https://x.com/BaksoOnSolana" style={{ color: '#ccc', textDecoration: 'none' }}>X</Link></p>
          <p><Link to="https://jup.ag/swap/SOL-FqnqT1GKi8S4Gyk5wnSKvJjXW48HqGtKJt9WS4o2pump" style={{ color: '#ccc', textDecoration: 'none' }}>Jupiter</Link></p>
          <p><Link to="https://t.me/baksosolportal" style={{ color: '#ccc', textDecoration: 'none' }}>Telegram</Link></p>
          <p><Link to="https://www.tiktok.com/@bakso_tiger" style={{ color: '#ccc', textDecoration: 'none' }}>TikTok</Link></p>
          <p><Link to="https://www.youtube.com/@BaksoSolana" style={{ color: '#ccc', textDecoration: 'none' }}>YouTube</Link></p>
          <p><Link to="https://www.instagram.com/baksoonsolana" style={{ color: '#ccc', textDecoration: 'none' }}>Instagram</Link></p>
        </div>
      
        
       <div className={styles.footerSection}>
          <h3>Quick Links</h3>
          <p><Link to="/" style={{ color: '#ccc', textDecoration: 'none' }}>Home</Link></p>
          {/*<p><Link to="/roarmap" style={{ color: '#ccc', textDecoration: 'none' }}>RoarMap</Link></p>*/}
          <p><Link to="/gallery" style={{ color: '#ccc', textDecoration: 'none' }}>Gallery</Link></p>
          {/*<p><Link to="/conservation" style={{ color: '#ccc', textDecoration: 'none' }}>Conservation Efforts</Link></p>*/}
          <p><Link to="/games" style={{ color: '#ccc', textDecoration: 'none' }}>Games</Link></p>
        </div>
      </div>
      
      <div className={styles.copyright}>
        <p>&copy; {new Date().getFullYear()} Bakso the Tiger Fan Page. This is an unofficial fan page not affiliated with Disney.</p>
        <p>Photo credits: Disney Parks, thedakguy</p>
      </div>
    </footer>
  );
};

export default Footer;